import React from 'react';
import { FormattedMessage } from 'react-intl';
import { quoteClicked } from '../presentation.utils';
import { AnimatedLink } from '../../components/animated-link/AnimatedLink';

import './presentation_banner.scss';
import '../quote_block.scss';

export class KeyInformation extends React.Component<{}> {
  render() {
    return (
      <div className="presentation-banner__no_flex_border">
        <div className="banner-customers__block">
          <div className="presentation-banner__image_right">
            <img
              className="presentation-banner__image_bench"
              src="/img/features/graphic-frise.png"
              alt="graphic"
            />
          </div>
          <div className="presentation-banner__text_left">
            <h2 className="presentation-banner__title">
              <FormattedMessage id="presentation/presentation-banner/KeyInformation.tsx/1" />
            </h2>
            <p className="banner-customers__subtitle">
              <FormattedMessage id="presentation/presentation-banner/KeyInformation.tsx/2" />
            </p>
            <div>
              <p className="quote_block__citation_small">
                <em>
                  <FormattedMessage id="presentation/presentation-banner/KeyInformation.tsx/3" />
                </em>
              </p>
              <img
                className="quote_block__picture"
                src="/img/home/benedicte_papin.png"
                alt="benedicte_papin"
              />
              <p className="quote_block__legend">
                <FormattedMessage id="presentation/presentation-banner/KeyInformation.tsx/4" />
                <br />
                <FormattedMessage id="presentation/presentation-banner/KeyInformation.tsx/5" />
              </p>
              <div className="quote_block__link">
                <AnimatedLink
                  onClick={() => quoteClicked('Bénédicte Papin')}
                  className="quote_block__link"
                  href="/avis/benedicte-papin"
                  source="home_public"
                  target="_blank"
                >
                  <FormattedMessage id="presentation/presentation-banner/KeyInformation.tsx/6" />
                </AnimatedLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
